var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col"},[_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":_vm.pdfUrl}},[_vm._v(_vm._s(_vm.trans('Download PDF')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }